<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-pm-layout">
            <div class="dw-pm-header">
                <div class="dw-pm-hero">
                    <div class="dw-pm-hero-left">
                        <span class="dw-pm-total-val">{{ totalFormatted }}</span>
                        <span class="dw-pm-total-lbl">Toplam Tahsilat</span>
                    </div>
                </div>
                <div class="dw-summary-bar">
                    <div v-for="(pm, i) in items" :key="pm.method_code || i" class="dw-summary-seg" :style="{ flex: percentOf(pm), background: colors[i % colors.length] }">
                        <span class="dw-summary-tooltip">{{ pm.method_name }}: {{ fmt(pm.total_amount) }}</span>
                    </div>
                </div>
            </div>
            <div class="dw-pm-list">
                <div class="dw-pm-row" v-for="(pm, i) in items" :key="pm.method_code || i">
                    <span class="dw-pm-dot" :style="{ background: colors[i % colors.length] }"></span>
                    <span class="dw-pm-name">{{ pm.method_name }}</span>
                    <span class="dw-pm-pct">%{{ percentOf(pm) }}</span>
                    <span class="dw-pm-val">{{ fmt(pm.total_amount) }}</span>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';
import { cssVar } from '../chartOpts';

export const meta = {
    id: 'payment_methods',
    titleKey: 'common.dashboard.widgetTitles.payment_methods',
    icon: 'bi-credit-card',
    accent: '#3B82F6',
    accentBg: 'rgba(59, 130, 246, 0.12)',
    glassRgb: '59, 130, 246',
    defaultCol: 2,
    defaultRow: 1,
    source: { type: 'statistics', key: 'payment_methods' },
};

export default {
    name: 'PaymentMethodsWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        items() {
            return Array.isArray(this.apiData) ? this.apiData : [];
        },
        total() {
            return this.items.reduce((sum, pm) => sum + (parseFloat(pm.total_amount) || 0), 0);
        },
        totalFormatted() {
            return this.total.toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
        },
        colors() {
            return [
                cssVar('--bs-success', '#50CD89'),
                '#3B82F6',
                cssVar('--bs-info', '#7239EA'),
                cssVar('--bs-warning', '#FFC700'),
                cssVar('--bs-gray-500', '#A1A5B7'),
            ];
        },
    },
    methods: {
        fmt(n) {
            return (parseFloat(n) || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
        },
        percentOf(pm) {
            if (!this.total) return 0;
            return Math.round(((parseFloat(pm.total_amount) || 0) / this.total) * 100);
        },
    },
};
</script>
